import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "stretch",
        minWidth: 0
    }
});
export default stylesheet;
